import React, { useState, useEffect } from "react";
import IndividualGeneral from "../IndividualSettings/General/index";
// import IndividualNotification from "../IndividualSettings/Notification/index";
import IndividualBilling from "../IndividualSettings/Billing/index";
import Settings from "components/Settings/SettingsMain/index";
import IndividualSecurity from "../IndividualSettings/Security/index";

import "./settings.scss";
// import useTheme from "hooks/observer";
import ChangePlan from "components/ChangePlan/index";
import Logs from "components/Logs/Logs";

function IndividualSetting({ changePlan, setChangePlan, onProfileUpdated }) {
  // Initialize activeTab from sessionStorage or default to 0
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("activeTab");
    return savedTab !== null ? parseInt(savedTab, 10) : 0;
  });
  const [editProfile, setEditProfile] = useState(false);

  // Save activeTab to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  // Read activeTab from sessionStorage when component mounts
  useEffect(() => {
    const savedTab = sessionStorage.getItem("activeTab");
    if (savedTab !== null) {
      setActiveTab(parseInt(savedTab, 10));
    }

    // Listen for the updateSettingsTab event
    const handleUpdateSettingsTab = () => {
      const savedTab = sessionStorage.getItem("activeTab");
      if (savedTab !== null) {
        setActiveTab(parseInt(savedTab, 10));
      }
    };

    window.addEventListener("updateSettingsTab", handleUpdateSettingsTab);

    return () => {
      window.removeEventListener("updateSettingsTab", handleUpdateSettingsTab);
    };
  }, []);

  const IndividualTabs = [
    <IndividualGeneral
      key={0}
      editProfile={editProfile}
      setEditProfile={setEditProfile}
      onProfileUpdated={onProfileUpdated}
    />,
    <IndividualSecurity key={1} />,
    <IndividualBilling
      key={3}
      changePlan={changePlan}
      setChangePlan={setChangePlan}
    />,
    <Logs organization={false} key={4}/>
  ];

  // const theme = useTheme();

  return (
    <div
      className="IndividualSetting"
      // style={{ backgroundColor: theme === "light" ? "#fff" : "#211D25" }}
    >
      <Settings activeTab={activeTab} setActiveTab={setActiveTab} />
      <div
        className={`IndividualSettingWrapper ${editProfile ? "IndividualSettingScroll" : ""}`}
      >
        {IndividualTabs[activeTab] || IndividualTabs[0]}
      </div>
    </div>
  );
}

function IndividualSettings({ searchQuery, setSearchQuery, onManageUserChange, onProfileUpdated }) {
  const [changePlan, setChangePlan] = useState(() => {
    // Check if we should open the Change Plan component directly
    const shouldOpenChangePlan =
      sessionStorage.getItem("openChangePlan") === "true";
    if (shouldOpenChangePlan) {
      // Clear the flag so it doesn't persist on page refresh
      sessionStorage.removeItem("openChangePlan");
      return true;
    }
    return false;
  });

  return (
    <>
      {changePlan ? (
        <ChangePlan setChangePlan={setChangePlan} />
      ) : (
        <IndividualSetting
          setChangePlan={setChangePlan}
          changePlan={changePlan}
          onProfileUpdated={onProfileUpdated}
        />
      )}
    </>
  );
}

export default IndividualSettings;
